export const FIND_TABLE_CONFIGS_FAILURE = 'FIND_TABLE_CONFIGS_FAILURE';

export const findTableConfigsFailure = error => ({
    type: FIND_TABLE_CONFIGS_FAILURE,
    payload: error,
    error: true,
});
